<template>
  <div class="news_card">
    <div class="menu_dropdown flexible_actions" v-if="[1 ,2].indexOf(getUserRoleId)>-1">
      <a href.prevent="" class="a-icon"><svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="custom-class feather feather-more-vertical"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg></a>
      <div class="menu_list_wrap">
        <ul class="menu_list">
          <li class="menu_item" v-if="false" @click="openPopup('Edit')">
            Edit  
          </li>
          <template v-if="checkProperty(newsItem, 'statusId') == 1">
            <li class="menu_item" @click="openPopup('Publish')">Publish</li>
            <li class="menu_item" @click="openPopup('Ignore')">Ignore</li>
          </template>
          <template v-if="checkProperty(newsItem, 'statusId') == 2">
            <li class="menu_item" @click="openPopup('Un Publish')">Unpublish</li>
            <li class="menu_item" @click="openPopup('Ignore')">Ignore</li>
          </template>
          <template v-if="checkProperty(newsItem, 'statusId') == 3">
            <li class="menu_item" @click="openPopup('Publish')">Publish</li>
          </template>
          <template v-if="[3].indexOf(checkProperty(newsItem, 'statusId'))<=-1">
            <li class="menu_item" @click="openPopup('Manage Category')"> Manage Category</li>
          </template>
        </ul>
      </div>
    </div>
    <div class="card_cnt cursor" @click="showDetailsItem()">
        <label class="cursor"  v-if="checkProperty( newsItem , 'title' )" :title="checkProperty( newsItem ,'title' )" >{{getTrimmedContent(checkProperty( newsItem ,"title" ))}}</label>
        <!-- <label v-if="false" >{{checkProperty( newsItem  internalPubDate ,"title" )}}</label> -->
        <p v-if="checkProperty( newsItem , 'description' )">{{getTrimmedDescription(checkProperty( newsItem ,"description" ))}}</p>
        
        <template v-if="[1,2].indexOf(getUserRoleId)>-1">
          <div class="d-flex align-center flex-wrap">
            <p class="created-info mr-2" v-if="checkProperty( newsItem ,'pubDate')"><span >Date</span>
              {{checkProperty( newsItem ,"pubDate") | formatDate}}
            </p>
            <p class="created-info" v-if="checkProperty( newsItem ,'internalPubDate')"><span>Published Date</span>
              {{checkProperty( newsItem ,"internalPubDate") | formatDate}}
            </p>
          </div>
        </template>
        <span v-if="[1,2].indexOf(getUserRoleId)<=-1 && checkProperty( newsItem ,'internalPubDate')">{{checkProperty( newsItem ,"internalPubDate") | formatDate}}</span>
        <template v-if="checkProperty(newsItem ,'categoryName')">
          <span class="categories">{{checkProperty(newsItem ,'categoryName')}}</span>
        </template>
        <template v-if="checkProperty( newsItem ,'statusId') && [1,2].indexOf(getUserRoleId)>-1">
          <template v-if="checkProperty( newsItem ,'statusId') == 1">
            <!-- status_inProcess -->
            <span class="status status_inProcess cursor"><small>New</small></span>
          </template>
          <template v-if="checkProperty( newsItem ,'statusId') == 2">
            <!-- status_created -->
            <span class="status status_created cursor"><small>Published</small></span>
          </template>
          <template v-if="checkProperty( newsItem ,'statusId') == 3">
            <!-- status_denied -->
            <span class="status status_denied cursor"><small>Ignored</small></span>
          </template>
        </template>
       
        <span class="link_arrow_news"></span>
    </div>
    <vs-popup class="holamundo main-popup cls-btn" :title="popupTile" :active.sync="showPopup">
      <div class="form-container">
          <div class="vx-row">
              <div class="vx-col w-full">
                  <p style="line-height: 20px">
                    Are you sure to continue?
                  </p>
              </div>
          </div>
      </div>
      <div class="popup-footer">
          <vs-button color="dark" class="cancel" type="filled" @click="showPopup = false;selectedCategory='';clearNews()">No</vs-button>
          <vs-button @click="manageNews(selectedCategory);" class="save questionnaire_btn" type="filled">Yes </vs-button>
      </div>
    </vs-popup>
    <modal 
        :name="'editNewsCatModal'+keyVal" 
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="500px"
        height="auto">
        <div class="v-modal">
            <div class="popup-header fromDetailsPage">
                <h2 class="popup-title">  Edit News</h2>
                <span @click="$modal.hide('editNewsCatModal'+keyVal)">
                <em class="material-icons">close</em>
                </span>
            </div>
            <form @submit.prevent data-vv-scope="newsEditForm" @click="formError= ''" >
                <div class="form-container" @click="formError=''">
                    <div class="vx-row">
                        <immiInput :display="true"  :wrapclass="'md:w-full'"   cid="title" formscope="newsEditForm" v-model="seletedItem.title"  :fieldName="'title'"  :required="true"  label="Title" placeHolder="Title" />
                        <immiInput :display="true"  :wrapclass="'md:w-full'"   cid="link" formscope="newsEditForm" v-model="seletedItem.link"  :fieldName="'link'"  :required="true"  label="Link" placeHolder="Link" />

                        <div class="vx-col w-full">
                        
                        <quillTextEditor :wrapclass="'form_group'"  :fieldName="'description'" :required="true" :tplsection="'description'" :tplkey="'description'" :cid="'description'"
                        :customValidNotRequire="false" v-model="seletedItem.description" :canSpellCheck="true" label="Description" placeHolder="Description" :vvas="'Description'"/>
                      </div>
                      </div>

                    <div class="text-danger text-sm formerrors custom_margin" v-show="formError">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                        icon="IP-information-button" active="true">{{ formError }}</vs-alert>
                    </div>
                    <div class="popup-footer relative">
                        <span class="loader" v-if="loadingCategory" ><img src="@/assets/images/main/loader.gif" /></span>
                        <vs-button color="dark" @click="clearEditData()" class="cancel" type="filled">Cancel</vs-button>
                        <vs-button color="success" @click="addNewCategory()" class="save" type="filled">Submit</vs-button>
                    </div>
                </div>
            </form>
        </div>
    </modal> 
    <modal 
      :name="'manageCategroyModal'+keyVal" 
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto">
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Manage Category</h2>
          <span @click="$modal.hide('manageCategroyModal'+keyVal)">
          <em class="material-icons">close</em>
          </span>
        </div>
        <form @submit.prevent data-vv-scope="manageCatForm" @click="formError= ''" >
          <div class="form-container" @click="formError=''">
            <div class="vx-row"> 
              <div class="vx-col md:w-full w-full">
                <div class="form_group city-form">
                  <div class="con-select select-large addselect">
                    <label class="form_label">Category</label>
                    <multiselect
                      :name="'selectedManageCategory'"
                      v-model="selectedManageCategory"
                      
                      :show-labels="false"
                      track-by="id"
                      label="name"
                      data-vv-as="Category"
                      tag-placeholder="Add"
                      :taggable="true"
                      @tag="addCategory"
                      placeholder="Select Category"
                      :options="categoryList"
                      :searchable="true"
                      :allow-empty="false"
                      v-validate="'required'"
                    >
                      <span slot="noResult">No Category Found</span>
                    </multiselect>
                  </div>
                  <span
                    class="text-danger text-sm"
                    v-show="
                      errors.has(
                        ('manageCatForm' + '.') + 'Category' + 'selectedManageCategory'
                      )
                    "
                    >{{
                      errors.first(
                        ('manageCatForm' + '.') + "Category" + 'selectedManageCategory'
                      )
                    }}</span
                  >
                </div>
              </div>
            </div>
            <div class="text-danger text-sm formerrors custom_margin" v-show="formError">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formError }}</vs-alert>
            </div>
            <div class="popup-footer relative">
              <span class="loader" v-if="loadingCategory" ><img src="@/assets/images/main/loader.gif" /></span>
              <vs-button color="dark" @click="selectedManageCategory=null;$modal.hide('manageCategroyModal'+keyVal) " class="cancel" type="filled">Cancel</vs-button>
              <vs-button color="success" @click="updateCategory()" class="save" type="filled">Submit</vs-button>
            </div>
          </div>
        </form>
      </div>
    </modal> 
  </div>

</template>

<script>
import selectField from "@/views/forms/fields/simpleselect.vue";
import immiInput from "@/views/forms/fields/simpleinput.vue";
import quillTextEditor from "@/views/forms/fields/quillTextEditor.vue";
export default {
    provide() {
      return {
          parentValidator: this.$validator,
      };
    },
    components: {
      immiInput,
      quillTextEditor,
      selectField
    },
    props: {
      keyVal:0,
      newsItem: null,
      categoryList:{
        type:Array,
        default:null
      }
    },
    methods: {
      getTrimmedContent(content) {

        // Strip HTML tags using a temporary element
        const tempElement = document.createElement("div");
        tempElement.innerHTML = content;
        const plainText = tempElement.textContent || tempElement.innerText || "";

        // Trim the content to 200 characters and add "..." if needed
        const trimmedText = plainText.length > 70 ? plainText.slice(0, 70) + "..." : plainText;

        return trimmedText;
      },
      getTrimmedDescription(content) {
        // Strip HTML tags using a temporary element
        const tempElement = document.createElement("div");
        tempElement.innerHTML = content;
        const plainText = tempElement.textContent || tempElement.innerText || "";

        // Trim the content to 200 characters and add "..." if needed
        const trimmedText = plainText.length > 115 ? plainText.slice(0, 115) + "..." : plainText;

        return trimmedText;
      },
      showDetailsItem(){
        if(this.newsItem && this.checkProperty(this.newsItem, 'link')){
          let url = this.checkProperty(this.newsItem, 'link');
          window.open(url, '_blank');
        }
        //this.$emit('showDetailsItem', this.newsItem)
      },
      addCategory(newTag=''){
        if(!newTag){
          return false;
        } 
        let path = '/masterdata/add';
        let pLoad= {
          category:"news_category",
          name:newTag
        }
        this.$store.dispatch("commonAction", {data:pLoad, path:path})
        .then((response) => {
          if(response && this.checkProperty(response, 'data')){
            let tag = response['data'];
            this.categoryList.push(tag);
            this.selectedManageCategory = tag;
            this.$emit('reloadCategoryList'); 
          }
          
         
          // this.updateCategory(); {"message":"Data is saved successfully.","data":{"_id":"65d4822de21f06d888b93db1","id":6,"name":"DOL","__v":0},"id":6,"name":"DOL"}
        })
        .catch((error) => {
          this.loading = false;
        });
      },
      updateEditData(){
        if(this.checkProperty(this.newsItem, 'title')){
          this.seletedItem['title'] = this.checkProperty(this.newsItem, 'title');
        }
        if(this.checkProperty(this.newsItem, 'description')){
          this.seletedItem['description'] = this.checkProperty(this.newsItem, 'description');
        }
        if(this.checkProperty(this.newsItem, 'link')){
          this.seletedItem['link'] = this.checkProperty(this.newsItem, 'link');
        }
        if(this.checkProperty(this.newsItem, '_id')){
          this.seletedItem['newsId'] = this.checkProperty(this.newsItem, '_id');
        }
      },
      openPopup(category){
        if( category == 'Manage Category'){
          if(this.checkProperty(this.newsItem, 'categoryId') ){
            let findObj = _.find(this.categoryList, {'_id':this.newsItem['categoryId']});
            if(findObj){
              this.selectedManageCategory = findObj;
            }
            // this.selectedManageCategory = _.cloneDeep(this.newsItem['category'])
          }
          this.$modal.show('manageCategroyModal'+this.keyVal)
        }else if(category == 'Edit'){
          this.$modal.show('editNewsCatModal'+this.keyVal)
        }else{
          this.selectedCategory = category;
          this.showPopup = true;
          this.popupTile = category;
        }
      },
      manageNews(){
          let payLoad = {
            newsId:this.checkProperty(this.newsItem, '_id')
          };
          if(this.selectedCategory == 'Publish'){
            payLoad['statusId'] = 2;
          }
          if(this.selectedCategory == 'Un Publish'){
            payLoad['statusId'] = 1;
          }
          if(this.selectedCategory == 'Ignore'){
            payLoad['statusId'] = 3;
          };
          let path = '/news/status-update'
          this.$store.dispatch('commonAction', {data:payLoad, path:'/news/status-update'})
          .then((response)=>{
            this.showToster({message:response.message ,isError:false});
            this.clearNews();
            setTimeout(()=>{
              this.$emit('reloadList');
            })
           
            
          })
          .catch((err)=>{
            this.showToster({message:response.message ,isError:true});
            this.clearNews();
          })

      },
      clearNews(){
        this.selectedCategory = '';
        this.showPopup = false;
        this.popupTile = '';
      },
      clearEditData(){
        this.seletedItem = {
          title:'',
          description:'',
          link:'',
          newsId:''
        };
        this.$modal.hide('editNewsCatModal'+this.keyVal)
      },
      updateNews(){
        let payload = _.cloneDeep(this.seletedItem);

      },
      updateCategory(){
        this.$validator.validateAll('manageCatForm').then(result => {
        if(result){
          let payload = {
          newsId:this.checkProperty(this.newsItem, '_id'),
          categoryId:this.checkProperty(this.selectedManageCategory, '_id'),
          categoryName:this.checkProperty(this.selectedManageCategory, 'name'),
        };
        let path = '/news/manage-category'
          this.$store.dispatch('commonAction', {data:payload, path:path})
          .then((response)=>{
            this.selectedManageCategory = null;
            this.showToster({message:response.message ,isError:false});
            this.$modal.hide('manageCategroyModal'+this.keyVal)
            // this.clearNews();
            setTimeout(()=>{
              this.$emit('reloadList');
            })
           
            
          })
          .catch((err)=>{
            this.showToster({message:response.message ,isError:true});
            this.clearNews();
          })
        }
       
        })
      },
    },
    data: () => ({
      selectedManageCategory:null,
      loadingCategory:false,
      formError:'',
      popupTile:'',
      showPopup:false,
      seletedItem:{
        title:'',
        description:'',
        link:'',
        newsId:''
      },
      selectedCategory:'',
    }),
    mounted() {
      this.updateEditData()
    },
    computed: {

    }
}
</script>
